import React, { useEffect, useState, useContext } from "react";

import Modal from "../../modal";
import PegholeCapture from "./peghole";
import { TaskContext } from "contexts/task";

import { getFrontShot, pegDescriptionMap } from "./lib/data";

import "./peg-measurement.scss";

const displayMeasurements = (measurements) => {
    if (!measurements) {
        return null;
    }

    return measurements.map((p, i) => {
        const text = Object.keys(p.Measurements).map((m) => {
            return (
                <div key={`${i}_${m}`}>
                    {m}: {p.Measurements[m]}
                </div>
            );
        });

        return (
            <div key={`measurement_${i}`} className="selected-item">
                <h4>
                    {pegDescriptionMap[p.TypeCode]} ({p.TypeCode})
                </h4>
                {text}
            </div>
        );
    });
};

const PegMeasurements = (props) => {
    const [frontShot, setFrontShot] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { task } = useContext(TaskContext);
    useEffect(() => {
        async function fetchData() {
            const newFrontShot = await getFrontShot(props.photoWipKey);
            setFrontShot(newFrontShot);
        }

        fetchData();
    }, []);

    const updateOnChange = (value) => {
        props.updateMany({
            [props.name]: value,
        });
        closeModal();
    };

    const openModal = () => {
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div className="peg-measurements">
            {displayMeasurements(props.defaultValue)}

            <div>
                <button className="button" onClick={openModal} disabled={props.disabled}>
                    Modify
                </button>
                <Modal show={showModal} onClose={closeModal}>
                    <PegholeCapture
                        shot={frontShot}
                        photoWipKey={props.photoWipKey}
                        defaultValue={props.defaultValue}
                        updateOnChange={updateOnChange}
                        sourcePage={task.sourcePage}
                        isReadOnly={props.disabled}
                    />
                </Modal>
            </div>
        </div>
    );
};

export default PegMeasurements;
